import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import {
  advancedSearchQuery,
  advancedSearchWithUserConfigurationQuery,
  agencyInvolvementOptionsQuery,
  hasBulkEditingOperationInProgressQuery
} from '@app/pcs/data/advanced-search.queries';
import { DossierSearchCriteria, DossierSearchType } from '@app/pcs/models';
import { UserGridType } from '@app/pcs/models/user-grid-type';
import { map } from 'rxjs/operators';

@Injectable()
export class AdvancedSearchDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  searchWithUserConfiguration(searchCriteria: DossierSearchCriteria, userGridType: UserGridType) {
    return this.graphqlService.query(advancedSearchWithUserConfigurationQuery, {
      searchCriteria,
      userGridType: {id: userGridType}
    }).pipe(map(response => ({
      searchResults: response[0],
      userGridConfiguration: response[1]
    })));
  }

  search(searchCriteria: DossierSearchCriteria) {
    return this.graphqlService.query(advancedSearchQuery, {searchCriteria});
  }

  hasBulkEditingOperationInProgress(dossierSearchType: DossierSearchType) {
    return this.graphqlService.query(hasBulkEditingOperationInProgressQuery, {dossierSearchType: {id: dossierSearchType}}, hideLoader());
  }

  fetchAgencyInvolvementOptions() {
    return this.graphqlService.query(agencyInvolvementOptionsQuery, hideLoader());
  }
}
